export class TextItem {
    English: string = '';
    French: string = '';
}
